import { FC, useEffect } from 'react';
import { Route } from 'react-router-dom';

const ExternalRedirect: FC<{ to: string }> = ({ to }) => {
    useEffect(() => {
        window.location.href = to;
    }, [to]);
    return null;
};

interface ExternalRedirectRouteProps {
    from: string;
    to: string;
}

export const ExternalRedirectRoute: FC<ExternalRedirectRouteProps> = ({ from, to }) => {
    return <Route path={from} render={() => <ExternalRedirect to={to} />} />;
};
